import { render, staticRenderFns } from "./ElementStructure.vue?vue&type=template&id=4518dfb6&scoped=true&"
import script from "./ElementStructure.vue?vue&type=script&lang=js&"
export * from "./ElementStructure.vue?vue&type=script&lang=js&"
import style0 from "./ElementStructure.vue?vue&type=style&index=0&id=4518dfb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4518dfb6",
  null
  
)

export default component.exports